var RING=window.__ES_A["a-ec3c1bd202.png"];document.querySelectorAll("[data-ring]").forEach(function(i){i.src=RING});renderPdp();
(function(){
function bindSel(sel,kind){
  var list=kind==='ring'?SCENTS:SCENTS.filter(function(s){return s.g!=='seasonal'&&s.n!=='create it'});
  sel.innerHTML=list.map(function(s){return '<option>'+s.n+'</option>'}).join('');
  var item=sel.closest('.bb-item');if(!item)return;
  var img=item.querySelector('img');if(!img)return;
  var up=function(){var s=null;for(var i=0;i<SCENTS.length;i++){if(SCENTS[i].n===sel.value){s=SCENTS[i];break}}
    if(s){var slug=s.img.slice(3);var u=kind==='ring'?imSrc(s.img):(imSrc('ob-'+slug)||imSrc(s.img));if(u){img.src=u}}};
  sel.addEventListener('change',up);up();
}
document.querySelectorAll('select[aria-label="ring scent"]').forEach(function(x){bindSel(x,'ring')});
document.querySelectorAll('select[aria-label="oil scent"]').forEach(function(x){bindSel(x,'oil')});
document.querySelectorAll('[data-simg]').forEach(function(i){var u=imSrc(i.getAttribute('data-simg'));if(u)i.src=u});if(typeof fxReset==='function'){fxReset()}
if(typeof renderOilPdp==='function'){renderOilPdp()}
(function(){var sh=document.getElementById('opShelf');if(!sh)return;
SCENTS.forEach(function(s,i){
  if(s.g==='seasonal'||s.n==='create it')return;
  var b=document.createElement('button');
  b.className='chip2';
  b.innerHTML='<span class="d" style="background:'+(SCOL[s.n]||'#999')+'"></span>'+s.n;
  b.onclick=function(){oilPdp.scent=i;renderOilPdp();opToggle()};
  sh.appendChild(b);
});})();
(function(){var host=document.getElementById('scAll');if(!host)return;
var GROUPS=ARC.concat(['custom','seasonal']);
var GLABEL={custom:'make it yours',seasonal:'for a limited time'};
GROUPS.forEach(function(g){
  var items=[];SCENTS.forEach(function(s,i){if((s.moods||[s.mood]).indexOf(g)!==-1)items.push(i)});
  if(!items.length)return;
  var head=document.createElement('div');head.className='sc-mood-head';
  var isMood=!!MOODS[g];
  head.innerHTML='<span class="sc-mood-band" style="background:'+(isMood?'var(--'+g+')':'var(--sand)')+'"></span><h2>'+g+'</h2><span class="serif">'+(isMood?(MOODW[g]||''):(GLABEL[g]||''))+'</span>'
    +(isMood?'<a href="#" style="margin-left:auto;font-size:13px;font-weight:700;color:var(--lagoon-deep)" onclick="goHub(\''+g+'\');return false">the '+g+' shelf &rsaquo;</a>':'');
  host.appendChild(head);
  var grid=document.createElement('div');grid.className='sc-grid';
  items.forEach(function(i){
    var s=SCENTS[i];var col=SCOL[s.n]||'#999';var thumb=imSrc('scw-'+s.img.slice(3))||imSrc(s.img);
    var card=document.createElement('div');card.className='ing';
    card.setAttribute('data-n',s.n);card.setAttribute('data-moods',(s.moods||[s.mood]).join(','));
    card.innerHTML=(thumb?'<div class="ing-imgw" style="background:'+(SEDGE[s.img]||col)+'" onclick="openScentPdp('+i+')"><img loading="lazy" decoding="async" src="'+thumb+'" alt="'+s.n+'"></div>':'')
      +'<div class="ing-body"><b style="cursor:pointer" onclick="openScentPdp('+i+')">'+s.n+'</b>'
      +'<p>'+(s.a||'')+'</p>'
      +'<div class="ing-buy"><select aria-label="'+s.n+' option"><option data-p="'+esRingPrice(s.n,'5-pack')+'">ring 5-pack \u00b7 $'+esRingPrice(s.n,'5-pack').toFixed(2)+'</option><option data-p="'+esRingPrice(s.n,'single')+'">single ring \u00b7 $'+esRingPrice(s.n,'single').toFixed(2)+'</option>'
      +(s.g!=='seasonal'&&s.n!=='create it'?'<option data-p="'+esOilPrice(s.n)+'">oil 5 mL \u00b7 $'+esOilPrice(s.n).toFixed(2)+'</option>':'')
      +'</select><button class="quick-add" onclick="ingAdd(this,\''+s.n+'\')">add</button></div></div>';
    grid.appendChild(card);
  });
  host.appendChild(grid);
});
var ctrl=document.getElementById('scCtrl');
if(ctrl){
  var cur='';
  var inp=document.createElement('input');inp.type='search';inp.placeholder='search scents';inp.setAttribute('aria-label','search scents');
  inp.style.cssText='flex:1;min-width:170px;max-width:300px;padding:10px 16px;border:1px solid var(--line);border-radius:999px;background:var(--white);font:inherit;font-size:14px';
  ctrl.appendChild(inp);
  function apply(){
    var q=inp.value.trim().toLowerCase();
    document.querySelectorAll('#scAll .ing').forEach(function(cd){
      var ok=(!q||(cd.getAttribute('data-n')||'').indexOf(q)>-1)&&(!cur||((cd.getAttribute('data-moods')||'').split(',').indexOf(cur)>-1));
      cd.style.display=ok?'':'none';
    });
    document.querySelectorAll('#scAll .sc-mood-head').forEach(function(h){
      var g=h.nextElementSibling,any=false;
      if(g)g.querySelectorAll('.ing').forEach(function(cd){if(cd.style.display!=='none')any=true});
      h.style.display=any?'':'none';if(g)g.style.display=any?'':'none';
    });
  }
  var chips=[];
  ARC.forEach(function(mo){
    var b=document.createElement('button');b.className='chip2';b.textContent=mo;
    b.style.cssText='border-color:var(--'+mo+')';
    b.onclick=function(){cur=(cur===mo)?'':mo;chips.forEach(function(cb){cb.style.background=cb.textContent===cur?'var(--'+cb.textContent+')':'';cb.style.color=''});apply()};
    chips.push(b);ctrl.appendChild(b);
  });
  inp.addEventListener('input',apply);
}
})();
var fs=document.querySelector('.slide-finder');var fw=imSrc('hero-finder-wide');if(fs&&fw){fs.style.background='var(--cream) url("'+fw+'") no-repeat center right / cover'}var bs=document.querySelector('.slide-brand');var bw=imSrc('hero-brand-wide');if(bs&&bw){bs.style.background='var(--ink) url("'+bw+'") no-repeat center right / cover'}var hv=document.querySelector('.slide-video');if(hv){var hvKick=function(){hv.play().catch(function(){})};hvKick();document.addEventListener('visibilitychange',hvKick);window.addEventListener('pageshow',hvKick);setTimeout(hvKick,1200)}var ds=document.querySelector('.slide-duo');var dw=imSrc('hero-duo-wide');if(ds&&dw){ds.style.background='#0E6478 url("'+dw+'") no-repeat center right / cover'}var ps=document.querySelector('.slide-pumpkin');var pw=imSrc('hero-pumpkin-wide');if(ps&&pw){ps.style.background='#4a2410 url("'+pw+'") no-repeat center right / cover'}var cn=document.getElementById('clubNext');if(cn&&pw){cn.style.background='linear-gradient(90deg,rgba(74,36,16,.94) 30%,rgba(74,36,16,.55)),url("'+pw+'") no-repeat center right / cover'}})();
(function(){var q=new URLSearchParams(location.search);if(q.get('mega')){var mb=document.querySelector('[data-mega="'+q.get('mega')+'"]');if(mb){mb.click()}}var v=q.get('v');if(!v)return;
if(v==='hub'&&q.get('m')&&MOODS[q.get('m')]){goHub(q.get('m'))}
else if(v==='pdp'){var s=parseInt(q.get('s'),10);if(!isNaN(s)&&SCENTS[s]){pickScent(s)}go('pdp')}
else if(v==='oilpdp'){var so=parseInt(q.get('s'),10);openOilPdp(isNaN(so)?18:so)}
else if(v==='kitpdp'){var sk=parseInt(q.get('s'),10);openKitPdp(isNaN(sk)?0:sk)}
else if(v==='duopdp'){var sd=parseInt(q.get('s'),10);openDuoPdp(isNaN(sd)?0:sd)}
else if(document.getElementById('view-'+v)){go(v)}
if(q.get('y')){setTimeout(function(){scrollTo({top:parseInt(q.get('y'),10)||0,behavior:'instant'})},80)}})();
function prBuildOilGrid(){
  var grid=document.getElementById('prOilGrid');
  if(!grid) return;
  var q=document.getElementById('olSearch');
  if(q&&!q.__wired){q.__wired=1;q.addEventListener('input',function(){
    var v=q.value.trim().toLowerCase();
    grid.querySelectorAll('.pr-oil').forEach(function(cd){cd.style.display=(!v||(cd.getAttribute('data-n')||'').indexOf(v)>-1)?'':'none'});
  })}
  var SINGLES=['lemon','lemon-lime','orange','grapefruit','bergamot','lemongrass','coffee','peppermint','eucalyptus','frankincense','lavender'];
  function card(i){
    var s=SCENTS[i];
    var src=imSrc('ob-'+s.img.slice(3))||imSrc(s.img);
    var thumb=src?'<div class="pr-oil-stage" data-op="'+i+'" style="cursor:pointer"><img loading="lazy" decoding="async" src="'+src+'" alt="'+s.n+' oil bottle"></div>':'<div class="pr-oil-stage"></div>';
    return '<div class="pr-oil" data-n="'+s.n+'">'+thumb+
      '<div class="pr-oil-name" data-op="'+i+'" style="cursor:pointer"><span class="sdot" style="background:'+((typeof SCOL!=='undefined'&&SCOL[s.n])||'#999')+'"></span>'+s.n+'</div>'+
      '<div class="pr-oil-meta">5 mL \u00b7 $'+esOilPrice(s.n).toFixed(2)+'</div>'+
      '<button class="quick-add" data-oil="'+i+'">add</button></div>';
  }
  var singles='',blends='',i;
  for(i=0;i<SCENTS.length;i++){
    if(SCENTS[i].n==='create it'||SCENTS[i].g==='seasonal') continue;
    var one=card(i);
    if(SINGLES.indexOf(SCENTS[i].n)!==-1){singles+=one}else{blends+=one}
  }
  var head='style="grid-column:1/-1;margin:10px 0 0"';
  grid.innerHTML='<h2 id="oil-singles" '+head+'>single notes</h2>'+singles+
    '<h2 id="oil-blends" '+head+'>the blends</h2>'+blends+
    '<div id="oil-refills" style="grid-column:1/-1;background:var(--white);border:1px solid var(--line);border-radius:15px;padding:22px;display:flex;align-items:center;gap:18px;flex-wrap:wrap;margin-top:10px">'+
    '<div style="flex:1;min-width:240px"><h2 style="margin:0 0 6px">refill sets</h2><p class="serif" style="margin:0">stock the shelf: any five oils keep every ring in rotation. add five and the cart does the math.</p></div>'+
    '<button class="quick-add" style="flex:none" onclick="document.getElementById(\'oil-singles\').scrollIntoView({behavior:\'smooth\'})">pick your five</button></div>';
  grid.onclick=function(e){
    var t=e.target;
    if(t&&t.getAttribute&&t.getAttribute('data-oil')!==null){
      var idx=parseInt(t.getAttribute('data-oil'),10);
      quickAdd(SCENTS[idx].n+' oil 5 mL',esOilPrice(SCENTS[idx].n));
      return;
    }
    var op=t&&t.closest?t.closest('[data-op]'):null;
    if(op){openOilPdp(parseInt(op.getAttribute('data-op'),10))}
  };
}
function prWire(){
  var root=document.getElementById('view-products');
  if(!root) return;
  var goers=root.querySelectorAll('[data-go]');
  var i;
  for(i=0;i<goers.length;i++){
    (function(el){
      el.onclick=function(e){ if(e&&e.preventDefault)e.preventDefault(); go(el.getAttribute('data-go')); };
    })(goers[i]);
  }
  var adders=root.querySelectorAll('[data-add]');
  for(i=0;i<adders.length;i++){
    (function(el){
      el.onclick=function(){ esQuickAddSel(el); };
    })(adders[i]);
  }
  function on(id,fn){ var el=document.getElementById(id); if(el) el.onclick=function(e){ if(e&&e.preventDefault)e.preventDefault(); fn(); }; }
  on('prCtaMood',function(){ goHub('refresh'); });
  on('prCtaFinder',function(){ go('finder'); });
}
prBuildOilGrid();
prWire();
/* bundles view is static. quick adds and the builder link call the shared
   globals quickAdd() and go() straight from inline handlers, and images
   are filled by the shared data-simg loader. no extra wiring needed. */
var srIndex = [];
var srPopular = [];
function srBoot(){
  var i, moods, pages, popNames, j;
  for (i = 0; i < SCENTS.length; i++) {
    (function(idx){
      var s = SCENTS[idx];
      srIndex.push({ g: 'scent rings', t: s.n + " scent ring", s: s.a, run: function(){ openScentPdp(idx); } });
      if (s.g !== 'seasonal' && s.n !== 'create it') {
        srIndex.push({ g: 'oils', t: s.n + " oil, 5 mL", s: 'the refill. 30+ ring soaks per bottle.', run: function(){ if(typeof oilPdp!=='undefined'){oilPdp.scent=idx;if(typeof renderOilPdp==='function')renderOilPdp()} go('oilpdp'); } });
      }
    })(i);
  }
  moods = [["refresh","start again"],["focus","one thing at a time"],["breathe","clear runway"],["relief","back to baseline"],["relax","the day, done"],["sleep","lights out, actually"]];
  for (i = 0; i < moods.length; i++) {
    (function(m){
      srIndex.push({ g: 'moods', t: "the " + m[0] + " shelf", s: m[1], run: function(){ goHub(m[0]); } });
    })(moods[i]);
  }
  pages = [
    ["every scent", "all 23 rings, one page", function(){ go('scents'); }],
    ["the scent finder quiz", "eight quick questions, meet your ring", function(){ go('finder'); }],
    ["bundles and refresh kits", "curated sets, better together", function(){ go('bundles'); }],
    ["essence of the month", "the club. a new box, every month", function(){ go('club'); }],
    ["shop by product", "rings, oils, and refills", function(){ go('products'); }],
    ["the oils, 5 mL", "every scent\u2019s refill, $14.99", function(){ go('oils'); }],
    ["subscribe", "your mood, refilled monthly", function(){ go('subscribe'); }],
    ["learn how it works", "the science, minus the jargon", function(){ go('learn'); }],
    ["faq", "quick answers", function(){ goLearn('lrn-faq'); }],
    ["the journal", "notes on scent and mood", function(){ goLearn('lrn-journal'); }],
    ["pumpkin spice drop", "the seasonal one, live now", function(){ go('campaign'); }],
    ["the essence club", "the founding box: 5-pack, oil, bonus, wildcard", function(){ go('club'); }],
    ["the refresh kit", "2 rings + oil + soaking bay", function(){ openKitPdp(0); }],
    ["the scent & soak duo", "oil + topper + 2 rings, the whole loop", function(){ openDuoPdp(); }],
    ["soaking bays", "the overnight spa for tired rings", function(){ openCollection('bays'); }],
    ["travel cases", "for noses that leave the house", function(){ openCollection('travel'); }],
    ["tabletop diffusers", "whole-room scent, glass dome", function(){ openCollection('diffusers'); }],
    ["body care", "lotions in the house scents", function(){ openCollection('lotion'); }],
    ["our story", "two smelly flights and a shark tank", function(){ go('about'); }]
  ];
  for (i = 0; i < pages.length; i++) {
    (function(p){
      srIndex.push({ g: 'pages', t: p[0], s: p[1], run: p[2] });
    })(pages[i]);
  }
  popNames = ["lavender scent ring", "peppermint scent ring", "the scent finder quiz", "bundles and refresh kits", "faq"];
  for (i = 0; i < popNames.length; i++) {
    for (j = 0; j < srIndex.length; j++) {
      if (srIndex[j].t === popNames[i]) { srPopular.push(srIndex[j]); break; }
    }
  }
}
function srRow(entry){
  var b = document.createElement('button');
  b.className = 'sr-row';
  b.type = 'button';
  b.innerHTML = '<div class="sr-row-title"></div><div class="sr-row-sub"></div>';
  b.firstChild.textContent = entry.t;
  b.lastChild.textContent = entry.s;
  b.onclick = function(){ closeSearch(); entry.run(); };
  return b;
}
var srVisible = [], srSel = 0;
function srPaintSel(){
  var rows = document.querySelectorAll('#srResults .sr-row');
  for (var i = 0; i < rows.length; i++) {
    if (i === srSel) { rows[i].setAttribute('aria-current','true'); rows[i].scrollIntoView({block:'nearest'}); }
    else rows[i].removeAttribute('aria-current');
  }
}
function srRender(q){
  var box = document.getElementById('srResults');
  var i, e, lab, groups, gi, g;
  box.innerHTML = '';
  srVisible = []; srSel = 0;
  q = (q || '').toLowerCase().replace(/^\s+|\s+$/g, '');
  if (!q) {
    lab = document.createElement('div');
    lab.className = 'sr-label';
    lab.textContent = 'popular';
    box.appendChild(lab);
    for (i = 0; i < srPopular.length; i++) { srVisible.push(srPopular[i]); box.appendChild(srRow(srPopular[i])); }
    srPaintSel();
    return;
  }
  var words = q.split(/\s+/);
  var scored = [];
  for (i = 0; i < srIndex.length; i++) {
    e = srIndex[i];
    var hay = (e.t + ' ' + e.s).toLowerCase();
    var ok = true, ti = 0;
    for (var wi = 0; wi < words.length; wi++) { if (hay.indexOf(words[wi]) === -1) { ok = false; break; } }
    if (!ok) continue;
    if (e.t.toLowerCase().indexOf(words[0]) === 0) ti = 2;
    else if (e.t.toLowerCase().indexOf(words[0]) !== -1) ti = 1;
    scored.push([ti, e]);
  }
  scored.sort(function(a,b){ return b[0] - a[0]; });
  var hits = [];
  for (i = 0; i < scored.length && hits.length < 12; i++) hits.push(scored[i][1]);
  if (!hits.length) {
    lab = document.createElement('div');
    lab.className = 'sr-none';
    lab.textContent = 'nothing yet. try a scent, a mood, or "quiz".';
    box.appendChild(lab);
    return;
  }
  groups = [];
  for (i = 0; i < hits.length; i++) {
    g = hits[i].g || 'pages';
    if (groups.indexOf(g) === -1) groups.push(g);
  }
  for (gi = 0; gi < groups.length; gi++) {
    lab = document.createElement('div');
    lab.className = 'sr-label';
    lab.textContent = groups[gi];
    box.appendChild(lab);
    for (i = 0; i < hits.length; i++) {
      if ((hits[i].g || 'pages') === groups[gi]) { srVisible.push(hits[i]); box.appendChild(srRow(hits[i])); }
    }
  }
  srPaintSel();
}
function srOnKeydown(e){
  if (e.key === 'Escape' || e.keyCode === 27) { closeSearch(); return; }
  if (e.key === 'ArrowDown' || e.keyCode === 40) { e.preventDefault(); if (srSel < srVisible.length - 1) srSel++; srPaintSel(); return; }
  if (e.key === 'ArrowUp' || e.keyCode === 38) { e.preventDefault(); if (srSel > 0) srSel--; srPaintSel(); return; }
  if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); if (srVisible[srSel]) { closeSearch(); srVisible[srSel].run(); } return; }
}
window.openSearch = function(){
  if (!srIndex.length) srBoot();
  var ov = document.getElementById('searchOverlay');
  var inp = document.getElementById('srInput');
  ov.hidden = false;
  inp.value = '';
  srRender('');
  inp.focus();
  document.addEventListener('keydown', srOnKeydown);
};
window.closeSearch = function(){
  document.getElementById('searchOverlay').hidden = true;
  document.removeEventListener('keydown', srOnKeydown);
};
document.getElementById('srInput').addEventListener('input', function(){ srRender(this.value); });
document.getElementById('srInput').addEventListener('keydown', srOnKeydown);
(function(){
  var plans = document.getElementById('sbPlans');
  var cta = document.getElementById('sbCta');
  if (!plans || !cta) return;
  var cards = plans.getElementsByClassName('sb-plan');
  function labelFor(card){
    return card.getAttribute('data-plan') === 'essence of the month'
      ? 'start essence of the month · $19.99/mo'
      : 'start your pick · $18.69/mo';
  }
  function select(card){
    for (var i = 0; i < cards.length; i++) cards[i].removeAttribute('aria-current');
    card.setAttribute('aria-current', 'true');
    cta.textContent = labelFor(card);
  }
  for (var i = 0; i < cards.length; i++) {
    (function(card){
      card.onclick = function(){ select(card); if(card.getAttribute('data-plan')==='essence of the month'){go('club');setTimeout(function(){var b=document.querySelector('.club-month-band');if(b)b.scrollIntoView({behavior:'smooth'})},120);} };
      card.onkeydown = function(e){
        if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) { e.preventDefault(); select(card); }
      };
    })(cards[i]);
  }
  cta.onclick = function(){
    var sel = plans.querySelector('.sb-plan[aria-current="true"]') || cards[0];
    quickAdd(sel.getAttribute('data-plan') + ' subscription', parseFloat(sel.getAttribute('data-price')));
  };
})();

  /* fluid hero: apple-design sections 2, 3, 5, 6 */
  (function(){
    var sl=document.getElementById('heroSlider'); if(!sl) return;
    var drag=null, springRaf=null, springState=null, clickSquash=false;
    function els(){return sl.querySelectorAll('.slide')}
    function setX(el,x){el.style.transform='translateX('+x+'px)'}
    function clearInline(el){if(!el)return;el.style.transform='';el.style.display='';el.style.position='';el.style.inset='';el.style.zIndex=''}
    function project(v){var d=0.998;return (v/1000)*d/(1-d)}
    sl.addEventListener('pointerdown',function(e){
      if(e.pointerType==='mouse'&&e.button!==0)return;
      if(springRaf){ /* grab mid-flight: adopt the live value */
        cancelAnimationFrame(springRaf);springRaf=null;
        var s=springState;springState=null;
        drag={x0:e.clientX-s.x,y0:e.clientY,committed:true,hist:[],cur:s.cur,inc:s.inc,incIdx:s.incIdx,dir:s.dir,w:s.w,id:e.pointerId};
        try{sl.setPointerCapture(e.pointerId)}catch(err){}
        clickSquash=true;clearInterval(slideTimer);
        return;
      }
      drag={x0:e.clientX,y0:e.clientY,committed:false,hist:[],cur:null,inc:null,incIdx:-1,dir:0,w:sl.offsetWidth,id:e.pointerId};
    });
    sl.addEventListener('pointermove',function(e){
      if(!drag)return;
      var dx=e.clientX-drag.x0, dy=e.clientY-drag.y0;
      if(!drag.committed){
        if(Math.abs(dx)>10&&Math.abs(dx)>Math.abs(dy)){
          drag.committed=true;clickSquash=true;
          try{sl.setPointerCapture(drag.id)}catch(err){}
          clearInterval(slideTimer);
          drag.cur=els()[slideIdx];
          drag.cur.style.position='relative';drag.cur.style.zIndex='2';
        } else if(Math.abs(dy)>14){drag=null;return}
        else return;
      }
      var dir=dx<0?1:-1;
      if(dir!==drag.dir){
        clearInline(drag.inc);
        var all=els();
        drag.incIdx=(slideIdx+dir+all.length)%all.length;
        drag.inc=all[drag.incIdx];drag.dir=dir;
        drag.inc.style.display='block';drag.inc.style.position='absolute';drag.inc.style.inset='0';drag.inc.style.zIndex='1';
      }
      setX(drag.cur,dx);
      setX(drag.inc,drag.dir*drag.w+dx);
      drag.hist.push({x:e.clientX,t:e.timeStamp});
      if(drag.hist.length>6)drag.hist.shift();
    });
    function velocity(){
      var hh=drag.hist;if(hh.length<2)return 0;
      var a=hh[0],b=hh[hh.length-1],dt=(b.t-a.t)/1000;
      return dt>0?(b.x-a.x)/dt:0;
    }
    function finish(e){
      if(!drag)return;
      if(!drag.committed){drag=null;return}
      var dx=e.clientX-drag.x0, v=velocity();
      var commit;
      if(Math.abs(v)>400){commit=(v<0)===(drag.dir===1)}         /* velocity sign decides */
      else{var proj=dx+project(v);commit=Math.abs(proj)>drag.w/2} /* else momentum projection */
      var target=commit?-drag.dir*drag.w:0;
      var d=drag;drag=null;
      if(reduceMotion){settleNow(d,commit);return}
      var x=dx,vel=v,last=performance.now();
      springState={x:x,cur:d.cur,inc:d.inc,incIdx:d.incIdx,dir:d.dir,w:d.w};
      var watchdog=setTimeout(function(){if(springRaf){cancelAnimationFrame(springRaf);settleNow(d,commit)}},900);
      function step(now){
        var dt=Math.min((now-last)/1000,0.032);last=now;
        var F=-170*(x-target)-26*vel;
        vel+=F*dt;x+=vel*dt;
        springState.x=x;
        setX(d.cur,x);setX(d.inc,d.dir*d.w+x);
        if(Math.abs(x-target)<0.5&&Math.abs(vel)<20){clearTimeout(watchdog);settleNow(d,commit)}
        else{springRaf=requestAnimationFrame(step)}
      }
      springRaf=requestAnimationFrame(step);
    }
    function settleNow(d,commit){
      springRaf=null;springState=null;
      clearInline(d.cur);clearInline(d.inc);
      slideTo(commit?d.incIdx:slideIdx);
    }
    sl.addEventListener('pointerup',finish);
    sl.addEventListener('pointercancel',function(e){if(drag&&drag.committed){finish(e)}else{drag=null}});
    sl.addEventListener('click',function(e){if(clickSquash){e.stopPropagation();e.preventDefault();clickSquash=false}},true);
  })();
